import { useRecordContext } from 'react-admin';
import { formatDistanceToNow } from 'date-fns';

interface RelativeTimeFieldProps {
  source: string;
  record?: any;
  emptyText?: string;
}

/**
 * Displays a timestamp as relative time (e.g., "9 hours ago").
 * Shows "now" for items updated in the last minute.
 * Removes "about" prefix for cleaner display.
 */
export const RelativeTimeField = ({
  source,
  record: propRecord,
  emptyText,
}: RelativeTimeFieldProps) => {
  const contextRecord = useRecordContext();
  const record = propRecord || contextRecord;

  if (!record || !record[source])
    return emptyText ? <span>{emptyText}</span> : null;

  const date = new Date(record[source]);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  // Show "now" for items less than 1 minute old
  if (diffInSeconds < 60) {
    return <span>now</span>;
  }

  // Get relative time and remove "about", "over", "almost" prefixes
  let relativeTime = formatDistanceToNow(date, { addSuffix: true });
  relativeTime = relativeTime
    .replace(/^about /, '')
    .replace(/^over /, '')
    .replace(/^almost /, '');

  return <span>{relativeTime}</span>;
};
